import { Subject } from 'rxjs';
var config;
var userManager;
export var medicationNotification$ = new Subject();
export function displayMessage(message) {
    medicationNotification$.next({
        type: 'display',
        message: message
    });
}
export function displayError(message) {
    medicationNotification$.next({
        type: 'error',
        message: message
    });
}
export function createUserManagerSettings(appConfig) {
    var _a;
    var authConfig = {
        authority: appConfig.authentication.authority || '',
        clientId: appConfig.authentication.clientId || '',
        redirectUrl: ((_a = appConfig.authentication.redirectUrl) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '',
        additionalScopes: appConfig.authentication.additionalScopes || '',
        loadUserInfo: appConfig.authentication.loadUserInfo === 'false' ? 'false' : 'true',
        extraQueryParams: appConfig.authentication.extraQueryParams || {}
    };
    return {
        authority: authConfig.authority,
        client_id: authConfig.clientId,
        redirect_uri: authConfig.redirectUrl,
        response_type: 'id_token token',
        scope: "openid profile email " + authConfig.additionalScopes,
        post_logout_redirect_uri: authConfig.redirectUrl + "#logged_out",
        silent_redirect_uri: authConfig.redirectUrl + "renew.html",
        automaticSilentRenew: true,
        loadUserInfo: authConfig.loadUserInfo !== 'false',
        extraQueryParams: authConfig.extraQueryParams
    };
}
export function configureMedications(settings) {
    config = settings.appConfig;
    userManager = settings.userManager;
}
export var getConfig = function () {
    var globalAppConfig = config;
    if (globalAppConfig)
        return globalAppConfig;
    throw new Error('No config has been set, please make sure your application calls configureMedications');
};
export var getUserManager = function () {
    if (userManager)
        return userManager;
    throw new Error('User Manager was not created, please make sure your application calls configureMedications');
};
